export const LOG_EVENT_NAME = {
  viewedReleaseNoteList: 'viewed release note list',
  viewedReleaseNoteDetail: 'viewed release note',
  closedPopup: 'closed release note popup',
};
